import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'risk';
var loaded = loadState(STORE_KEY) || {};

const state = {
	riskData: loaded.riskData,
	kycData: loaded.kycData,
};

const mutations = {
	SET_RISK_DATA(state, data) {
		state.riskData = data;
		saveState(STORE_KEY, state);
	},
	SET_KYC_DATA(state, data) {
		state.kycData = data;
		saveState(STORE_KEY, state);
	},
	CLEAR_RISK_DATA(state) {
		state.riskData = {};
		saveState(STORE_KEY, state);
	},
};

const actions = {
	setRiskData({ commit }, data) {
		commit('SET_RISK_DATA', data);
	},
	setKycData({ commit }, data) {
		commit('SET_KYC_DATA', data);
	},
	clearRiskData({ commit }) {
		commit('CLEAR_RISK_DATA');
	},
};

const getters = {
	selectRiskData: (state) => state.riskData,
	selectKycData: (state) => state.kycData,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
